// Selection state for the guest date picker.
//
// react-day-picker's built-in `mode="range"` is deliberately NOT used: it
// extends the existing range on a third click (the bug this replaces) and has
// no notion of "check-out candidates become valid only once a check-in is
// chosen". Three explicit phases give both.

export type DateRangePhase = 'idle' | 'checkin-picked' | 'complete';

export interface DateRangeState {
  phase: DateRangePhase;
  checkin?: string;
  checkout?: string;
}

export type DateRangeAction =
  | { type: 'day-click'; date: string; canCheckin: boolean; canCheckout: boolean }
  | { type: 'clear' }
  | { type: 'set'; checkin?: string; checkout?: string };

export const initialDateRangeState: DateRangeState = { phase: 'idle' };

export function dateRangeReducer(
  state: DateRangeState,
  action: DateRangeAction,
): DateRangeState {
  switch (action.type) {
    case 'day-click': {
      if (state.phase === 'checkin-picked' && action.canCheckout) {
        return {
          phase: 'complete',
          checkin: state.checkin,
          checkout: action.date,
        };
      }
      if (action.canCheckin) {
        return { phase: 'checkin-picked', checkin: action.date };
      }
      // Neither role fits — the day should have been disabled; leave state
      // untouched rather than half-applying the click.
      return state;
    }
    case 'clear':
      return initialDateRangeState;
    case 'set': {
      if (action.checkin && action.checkout) {
        return { phase: 'complete', checkin: action.checkin, checkout: action.checkout };
      }
      if (action.checkin) {
        return { phase: 'checkin-picked', checkin: action.checkin };
      }
      return initialDateRangeState;
    }
  }
}
